import { Api } from '@axiom/ui';

import { EnvUtil } from '../utils/env-util';

class TermsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.clientApiBase,
    });
  }

  readTerms() {
    return super.read<string>({
      endpoint: '/files/axiom-tos.html',
      method: 'GET',
      headers: {},
    });
  }
}

export const TermsApi = new TermsApiClass();
